module.exports = __webpack_public_path__ + "static/img/case3.5f217ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case3.png
// module id = YJK3
// module chunks = 1